import React, { useContext, useEffect, useState } from 'react';
import { appAuthContext } from 'context/AuthContext';
import AuthModalController from 'components/AuthModalController/AuthModalController';
import VKAd from '../VKAd';
import { configuratorContext } from '../../context/ConfiguratorContext';
import useWindowWidth from '../../utils/useWindowWidth';
import useScrollPosition from '../../utils/useScrollPosition';
import useQuery from '../../utils/useQuery';
import LogoutModal from '../Modals/LogoutModal';
import AskModal from '../Modals/AskModal';
import { HeaderInfo } from './Header.data';
import getHeaderData from './api/getHeaderData';
import HeaderBanner from './components/HeaderBanner';
import OldHeader from './components/OldHeader/OldHeader';
import HeaderB2C from './components/HeaderB2C';
import HeaderB2T from './components/HeaderB2T';

import styles from './Header.module.css';

const Header = () => {
  const { user } = useContext(appAuthContext);
  const { banners } = useContext(configuratorContext);
  const windowWidth = useWindowWidth();

  const scrollPosition = useScrollPosition();
  const scrollMoreThanDefaultHeader = scrollPosition > 160;
  const scrollShowHeader = scrollPosition > 240;

  const isUserAuth = !!user?.data?.id && !!user?.data?.attributes?.type;
  const isUserStudent = user?.data?.attributes?.type === 'student';
  const isStudentGlobalTarget = user?.azTests?.otvety_global_student === 'target';
  const isB2CUser =
    isUserStudent && isStudentGlobalTarget && user?.included?.length === 0;

  const [showAskModal, setShowAskModal] = useState<boolean>(false);
  const [showRegModal, setShowRegModal] = useState<boolean>(false);
  const [showLogoutModal, setShowLogoutModal] = useState<boolean>(false);
  const [headerInfo, setHeaderInfo] = useState<HeaderInfo | null>(null);
  const [showSearch, setShowSearch] = useState(false);

  const setHeaderData = async () => {
    const counterData = await getHeaderData();
    setHeaderInfo(counterData);
  };

  useEffect(() => {
    setHeaderData();
  }, []);

  return (
    <>
      {banners?.otvety_top_banner ? (
        <HeaderBanner {...banners.otvety_top_banner} />
      ) : null}

      {banners?.otvety_top_banner === null && !user?.data?.attributes && (
        <VKAd
          slotId={windowWidth > 1023 ? '1531082' : '1531132'}
          maxWidth="100%"
          maxHeight={windowWidth > 1023 ? '90px' : '96px'}
          isSideBanner={false}
        />
      )}

      {scrollMoreThanDefaultHeader ? (
        <div className={styles.header__empty_block} />
      ) : null}
      <header
        id="header"
        className={`${styles.header} ${scrollShowHeader ? styles.header__sticky : ''} ${
          scrollMoreThanDefaultHeader ? styles.header__fixed : null
        }`}
      >
        {isB2CUser ? (
          //******* B2C HEADER *******//
          <HeaderB2C
            showSearch={showSearch}
            setShowSearch={setShowSearch}
            setShowAskModal={setShowAskModal}
            setShowRegModal={setShowRegModal}
            unanswered={headerInfo?.unanswered_count || null}
            setShowLogoutModal={setShowLogoutModal}
          />
        ) : isStudentGlobalTarget && !isB2CUser ? (
          //******* B2T HEADER *******//
          <HeaderB2T
            showSearch={showSearch}
            setShowSearch={setShowSearch}
            setShowAskModal={setShowAskModal}
            setShowRegModal={setShowRegModal}
            unanswered={headerInfo?.unanswered_count || null}
            setShowLogoutModal={setShowLogoutModal}
          />
        ) : (
          //******* OLD HEDADER *******//
          <OldHeader
            showSearch={showSearch}
            setShowSearch={setShowSearch}
            setShowAskModal={setShowAskModal}
            setShowRegModal={setShowRegModal}
            unanswered={headerInfo?.unanswered_count || null}
            userAuth={isUserAuth}
            setShowLogoutModal={setShowLogoutModal}
          />
        )}
        {showRegModal && (
          <AuthModalController
            handleClose={() => {
              setShowRegModal(false);
            }}
            entryPoint={'header'}
          />
        )}
        {showAskModal && (
          <AskModal onClose={() => setShowAskModal(false)} tryCreateNew="question" />
        )}
        {showLogoutModal && <LogoutModal onClose={() => setShowLogoutModal(false)} />}
      </header>
    </>
  );
};

export default Header;
